import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { setTokenGetter } from '../api/apiClient';

interface AuthInitializerProps {
  children: React.ReactNode;
}

/**
 * Component that initializes the auth token getter for API calls
 * This allows the axios client to access OIDC tokens
 */
export const AuthInitializer: React.FC<AuthInitializerProps> = ({ children }) => {
  const auth = useAuth();

  useEffect(() => {
    // Set up the token getter function for API client
    setTokenGetter(() => auth.user?.access_token);
  }, [auth.user?.access_token]);

  // Show loading state while auth is initializing
  if (auth.isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-neutral-600">Initializing authentication...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
